// extracted by css-extract-rspack-plugin
export default {"root":"root-uD-Y7","heading":"heading-16jwq","body":"body-3rXs8","medium":"medium-2DH1j","large":"large-U9Oa_"};